/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PatientSummaryDto } from '../models/PatientSummaryDto';
import type { UpsertPatientSummaryDto } from '../models/UpsertPatientSummaryDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { request as __request } from '../core/request';

export class PatientSummaryService {

    /**
     * Get the current Patient Summary for a referral
     * @param referralId
     * @returns PatientSummaryDto
     * @throws ApiError
     */
    public static patientSummaryControllerGet(
        referralId: string,
    ): CancelablePromise<PatientSummaryDto> {
        return __request({
            method: 'GET',
            path: `/patient-summary/${referralId}`,
        });
    }

    /**
     * Create or update the Patient Summary
     * @param requestBody
     * @returns PatientSummaryDto
     * @throws ApiError
     */
    public static patientSummaryControllerUpsert(
        requestBody: UpsertPatientSummaryDto,
    ): CancelablePromise<PatientSummaryDto> {
        return __request({
            method: 'PUT',
            path: `/patient-summary`,
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}